import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import { useNavigate } from "react-router-dom";
import {
  FaBookOpen,
  FaVideo,
  FaBullhorn,
  FaUserGraduate,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";

const StudentDashboard = () => {
  const [user, setUser] = useState(null);
  const [userName, setUserName] = useState("");
  const [courseDetails, setCourseDetails] = useState([]);
  const [expandedLectures, setExpandedLectures] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [activeLecture, setActiveLecture] = useState(null);
  const [activePDF, setActivePDF] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserAndEnrollments = async () => {
      const { data: sessionData } = await supabase.auth.getSession();
      const currentUser = sessionData.session?.user;
      setUser(currentUser);
      if (!currentUser) return;

      const { data: userDetails } = await supabase
        .from("users")
        .select("name")
        .eq("id", currentUser.id)
        .single();
      if (userDetails?.name) setUserName(userDetails.name);

      const { data: enrollments } = await supabase
        .from("course_enrollments")
        .select("course_id")
        .eq("student_id", currentUser.id);

      if (!enrollments?.length) return;

      const courseIds = enrollments.map((e) => e.course_id);

      const { data: courses } = await supabase
        .from("courses")
        .select("id, title")
        .in("id", courseIds);

      const { data: announcements } = await supabase
        .from("announcements")
        .select("id, content, course_id")
        .in("course_id", courseIds);

      const { data: lectures } = await supabase
        .from("lectures")
        .select("id, course_id, title, video_url, pdf_urls, created_at")
        .in("course_id", courseIds)
        .order("created_at", { ascending: true });

      const { data: accessData } = await supabase
        .from("lecture_access")
        .select("lecture_id, can_view")
        .eq("student_id", currentUser.id);

      const { data: courseTeachers } = await supabase
        .from("course_teachers")
        .select("course_id, teacher_id")
        .in("course_id", courseIds);

      const teacherIds = courseTeachers.map((ct) => ct.teacher_id);
      const { data: teachers } = await supabase
        .from("users")
        .select("id, email, name")
        .in("id", teacherIds);

      const accessibleLectureIds = new Set(
        accessData?.filter((a) => a.can_view).map((a) => a.lecture_id) || []
      );

      const enriched = courses.map((course) => {
        const thisCourseTeachers = courseTeachers.filter(
          (ct) => ct.course_id === course.id
        );
        return {
          ...course,
          teachers: thisCourseTeachers.map(
            (ct) => teachers.find((t) => t.id === ct.teacher_id)
          ),
          announcements: announcements.filter((a) => a.course_id === course.id),
          lectures: lectures.filter(
            (l) => l.course_id === course.id && accessibleLectureIds.has(l.id)
          ),
        };
      });

      setCourseDetails(enriched);
    };

    fetchUserAndEnrollments();
  }, []);

  const toggleExpand = (lectureId) => {
    setExpandedLectures((prev) =>
      prev.includes(lectureId)
        ? prev.filter((id) => id !== lectureId)
        : [...prev, lectureId]
    );
  };

  const getDriveEmbedUrl = (url) => {
    try {
      const match = url.match(/\/d\/(.*?)\//);
      if (match && match[1]) {
        return `https://drive.google.com/file/d/${match[1]}/preview`;
      }
      return url;
    } catch {
      return url;
    }
  };

  const getDriveDownloadUrl = (url) => {
    try {
      const match = url.match(/\/d\/(.*?)\//);
      if (match && match[1]) {
        return `https://drive.google.com/uc?export=download&id=${match[1]}`;
      }
      return url;
    } catch {
      return url;
    }
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/login");
  };

  const selectedCourse = courseDetails.find((c) => c.id === selectedCourseId);

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0f0c29, #302b63, #24243e)",
        color: "#fff",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
 {/* Sidebar Toggle */}
{/* Sidebar Toggle Button */}
<div
  style={{
    position: "fixed",
    top: "15px",
    left: "15px",
    zIndex: 12000,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "auto",
    height: "auto",
  }}
>
  <button
    onClick={() => setSidebarOpen(!sidebarOpen)}
    style={{
      margin: 0,
      padding: "8px 12px",
      background: "transparent",
      border: "none",
      borderRadius: "8px",
      color: "#fff",
      fontSize: "26px",
      cursor: "pointer",
    }}
  >
    {sidebarOpen ? <FaTimes /> : <FaBars />}
  </button>
</div>


{/* Sidebar */}
<aside
  style={{
    position: "fixed",
    top: 0,
    left: sidebarOpen ? 0 : "-280px",
    height: "100%",
    width: "260px",
    background: "#1a1835",
    transition: "all 0.3s ease",
    padding: "30px 20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    zIndex: 10001, // higher than backdrop
  }}
>
  <div>
    <h2
      style={{
        fontSize: "22px",
        fontWeight: "700",
        marginBottom: "20px",
        textAlign: "center",
        color: "#ff4081",
      }}
    >
      🎓 Dashboard
    </h2>

    {/* Profile Section */}
    <div style={{ textAlign: "center", marginBottom: "20px" }}>
      <button
        onClick={() => setProfileOpen(!profileOpen)}
        style={{
          background: "linear-gradient(135deg, #ff4081, #f50057)",
          border: "none",
          borderRadius: "50%",
          width: "70px",
          height: "70px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          color: "#fff",
          fontSize: "28px",
          margin: "0 auto",
        }}
      >
        <FaUserGraduate />
      </button>
      {profileOpen && (
        <div
          style={{
            background: "#2a2650",
            padding: "12px",
            borderRadius: "12px",
            marginTop: "12px",
            textAlign: "center",
            width: "100%",
            maxWidth: "220px",
            marginLeft: "auto",
            marginRight: "auto",
            wordWrap: "break-word",
            overflowWrap: "break-word",
          }}
        >
          <p style={{ fontWeight: "600", marginBottom: "6px", color: "#fff" }}>
            {userName || "Loading..."}
          </p>
          <p
            style={{
              fontSize: "13px",
              color: "#ccc",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={user?.email}
          >
            {user?.email || "Loading..."}
          </p>
        </div>
      )}
    </div>

    {/* Course Selector */}
    <div style={{ marginBottom: "20px" }}>
      <label
        style={{
          fontWeight: "600",
          display: "block",
          marginBottom: "8px",
        }}
      >
        Courses
      </label>
      <select
        value={selectedCourseId}
        onChange={(e) => setSelectedCourseId(e.target.value)}
        style={{
          width: "100%",
          padding: "12px",
          borderRadius: "12px",
          border: "none",
          fontWeight: "600",
          color: "#302b63",
        }}
      >
        <option value="">-- Select --</option>
        {courseDetails.map((c) => (
          <option key={c.id} value={c.id}>
            {c.title}
          </option>
        ))}
      </select>
    </div>

    {/* Announcements */}
    <div>
      <h3
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          color: "#ff80ab",
          marginBottom: "10px",
        }}
      >
        <FaBullhorn /> Announcements
      </h3>
      {selectedCourse && selectedCourse.announcements.length > 0 ? (
        selectedCourse.announcements.map((a) => (
          <div
            key={a.id}
            style={{
              background: "#2a2650",
              padding: "10px",
              borderRadius: "10px",
              marginBottom: "8px",
              fontSize: "14px",
            }}
          >
            {a.content}
          </div>
        ))
      ) : (
        <p style={{ fontSize: "13px", color: "#ccc" }}>No announcements yet.</p>
      )}
    </div>
  </div>

  {/* Logout */}
  <button
    onClick={handleLogout}
    style={{
      background: "linear-gradient(90deg,#ff4081,#f50057)",
      color: "#fff",
      padding: "12px",
      borderRadius: "12px",
      fontWeight: "600",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      cursor: "pointer",
      border: "none",
      marginTop: "20px",
    }}
  >
    <FiLogOut /> Logout
  </button>
</aside>

{/* Backdrop for Mobile */}
{sidebarOpen && (
  <div
    onClick={() => setSidebarOpen(false)}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0,0,0,0.5)",
      zIndex: 10000,
      display: window.innerWidth <= 768 ? "block" : "none",
    }}
  />
)}


      {/* Main Content */}
    <main
  style={{
    flex: 1,
    padding: "30px",
    marginLeft:
      sidebarOpen && window.innerWidth > 768 ? "260px" : "0px", // ✅ only push on desktop
    transition: "margin-left 0.3s ease",
    width: "100%",
  }}
>

        <h1 style={{ fontSize: "28px", marginBottom: "20px", color: "#ff80ab" }}>
          Welcome, {userName || user?.email || "Student"}
        </h1>

        {!selectedCourseId ? (
          <p>Please select a course to get started.</p>
        ) : selectedCourse ? (
          <div>
            {/* Course Card */}
            <div
              style={{
                background: "#2a2650",
                padding: "20px",
                borderRadius: "16px",
                marginBottom: "25px",
                boxShadow: "0 6px 18px rgba(0,0,0,0.3)",
              }}
            >
              <h2
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  color: "#ff80ab",
                }}
              >
                <FaBookOpen /> {selectedCourse.title}
              </h2>
              <p style={{ marginTop: "6px" }}>
                Instructor(s):{" "}
                {selectedCourse.teachers
                  .map((t) => t?.name || t?.email || "Unknown")
                  .join(", ")}
              </p>
            </div>

            {/* Lectures */}
            <div>
              <h3
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  color: "#ff4081",
                }}
              >
                <FaVideo /> Lectures
              </h3>
              {selectedCourse.lectures.length > 0 ? (
                selectedCourse.lectures.map((lec) => {
                  const embedUrl = getDriveEmbedUrl(lec.video_url);
                  return (
                    <div
                      key={lec.id}
                      style={{
                        background: "#2a2650",
                        padding: "18px",
                        borderRadius: "14px",
                        marginTop: "16px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => toggleExpand(lec.id)}
                      >
                        <span style={{ fontWeight: "600", fontSize: "18px" }}>
                          {lec.title}
                        </span>
                        <span>{expandedLectures.includes(lec.id) ? "▲" : "▼"}</span>
                      </div>

                      {expandedLectures.includes(lec.id) && (
                        <div style={{ marginTop: "12px" }}>
                          {embedUrl && (
                            <button
                              onClick={() => setActiveLecture(embedUrl)}
                              style={{
                                background: "linear-gradient(90deg,#ff4081,#f50057)",
                                color: "#fff",
                                padding: "10px 18px",
                                borderRadius: "12px",
                                border: "none",
                                fontWeight: "600",
                                cursor: "pointer",
                                marginBottom: "10px",
                              }}
                            >
                              ▶ Watch Lecture
                            </button>
                          )}
                          {lec.pdf_urls &&
                            lec.pdf_urls.map((url, i) => (
                              <button
                                key={i}
                                onClick={() => setActivePDF(getDriveEmbedUrl(url))}
                                style={{
                                  background: "linear-gradient(90deg,#7b1fa2,#9c27b0)",
                                  color: "#fff",
                                  padding: "8px 16px",
                                  borderRadius: "12px",
                                  border: "none",
                                  marginRight: "10px",
                                  marginBottom: "10px",
                                  cursor: "pointer",
                                  fontWeight: "600",
                                }}
                              >
                                📄 PDF {i + 1}
                              </button>
                            ))}
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <p>No lectures yet.</p>
              )}
            </div>
          </div>
        ) : null}
      </main>

      {/* Video Modal */}
      {activeLecture && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.9)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
        >
          <iframe
            src={activeLecture}
            style={{
              width: "85%",
              height: "70%",
              borderRadius: "12px",
              boxShadow: "0 8px 30px rgba(0,0,0,0.6)",
            }}
            allow="autoplay; encrypted-media"
            allowFullScreen
            sandbox="allow-scripts allow-same-origin allow-presentation"
            onContextMenu={(e) => e.preventDefault()}
          />
          <button
            onClick={() => setActiveLecture(null)}
            style={{
              marginTop: "15px",
              background: "linear-gradient(90deg,#ff4081,#f50057)",
              padding: "10px 20px",
              borderRadius: "12px",
              border: "none",
              color: "#fff",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>
      )}

      {/* PDF Modal */}
      {activePDF && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.8)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <iframe
            src={activePDF}
            style={{
              width: "80%",
              height: "75%",
              borderRadius: "12px",
              boxShadow: "0 8px 30px rgba(0,0,0,0.5)",
            }}
            title="pdf-fullscreen"
          />
          <div style={{ marginTop: "15px" }}>
            <button
              onClick={() => window.open(getDriveDownloadUrl(activePDF), "_blank")}
              style={{
                marginRight: "10px",
                background: "linear-gradient(90deg,#7b1fa2,#9c27b0)",
                padding: "10px 20px",
                borderRadius: "12px",
                border: "none",
                color: "#fff",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              ⬇ Download
            </button>
            <button
              onClick={() => setActivePDF(null)}
              style={{
                background: "linear-gradient(90deg,#ff4081,#f50057)",
                padding: "10px 20px",
                borderRadius: "12px",
                border: "none",
                color: "#fff",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div
>
  );
};

export default StudentDashboard;
